import { gql } from "@apollo/client";

const GET_USERS = gql`
  query getUsers(
    $searchTerm: String
    $groupIds: [UUID!]
    $hasPermissionOverrides: Boolean
    $sortBy: SkynetUserSortBy
    $sortDirection: SortDirection
    $skip: Int
    $take: Int
  ) {
    skynetUsers(
      searchTerm: $searchTerm
      groupIds: $groupIds
      hasPermissionOverrides: $hasPermissionOverrides
      sortBy: $sortBy
      sortDirection: $sortDirection
      skip: $skip
      take: $take
    ) {
      totalCount
      items {
        id
        firstName
        lastName
        email
        lastLoginAt
        groups {
          id
          groupName
          isGroupAdmin
          groupId
        }
      }
    }
  }
`;

export default GET_USERS;
